import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_DJANGO from "../../assets/img/skills/django.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import L_NEXT from "../../assets/img/skills/nex.svg.png";
import L_REDUX from "../../assets/img/skills/redux.png";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_HEROKU from "../../assets/img/skills/heroku.svg";
import L_GITHUB_PAGES from "../../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_PYTHON from "../../assets/img/skills/python.svg";
import L_C from "../../assets/img/skills/c.png";
import L_CL from "../../assets/img/skills/cl.png";
import L_NET from "../../assets/img/skills/netlify.jpg";
import L_FIRE from "../../assets/img/skills/firebase.png";
import L_OS from "../../assets/img/skills/os.png";
import L_CN from "../../assets/img/skills/cn.png";
import L_DBMS from "../../assets/img/skills/dbms.png";
import L_DS from "../../assets/img/skills/DS.png";
import L_OOPS from "../../assets/img/skills/oops.png";

export const skills = {
  frontend: [
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_NEXT,
      skillName: "Next JS",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REDUX,
      skillName: "REDUX",
    },
    // {
    //   link: "https://en.wikipedia.org/wiki/HTML5",
    //   imgAltText: "HTML 5",
    //   imgSrc: L_HTML5,
    //   skillName: "HTML5",
    // },
    // {
    //   link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
    //   imgAltText: "CSS 3",
    //   imgSrc: L_CSS3,
    //   skillName: "CSS3",
    // },

    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
  ],

  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    },
  ],
  hostingPlatforms: [
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },

    {
      link: "https://pages.github.com/",
      imgAltText: "GitHub Pages",
      imgSrc: L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
    {
      link: "https://www.netlify.com/",
      imgAltText: "Netlify",
      imgSrc: L_NET,
      skillName: "Netlify",
    },
  ],
  programmingLanguages: [
    {
      link: "https://isocpp.org/",
      imgAltText: "C++",
      imgSrc: L_C,
      skillName: "C++",
    },

    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
  ],
  databases: [
    // {
    //   link: "https://www.microsoft.com/en-us/sql-server/sql-server-2019",
    //   imgAltText: "MS-SQL",
    //   imgSrc: L_MSSQL,
    //   skillName: "MS-SQL",
    // },
    {
      link: "https://www.microsoft.com/en-us/sql-server/sql-server-2019",
      imgAltText: "MS-SQL",
      imgSrc: L_FIRE,
      skillName: "Firebase",
    },
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],

  technologies: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_DS,
      skillName: "DSA",
    },

    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_OOPS,
      skillName: "OOPs",
    },

    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_OS,
      skillName: "Operating System",
    },

    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_DBMS,
      skillName: "DBMS",
    },

    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_CN,
      skillName: "Computer Networks",
    },
  ],
};
